import View from '../Support/View/View';

export default class AskForAQuoteStep1 extends View {
    #templates = {
        service: null,
        activities: null,
    };
    #form = {
        self: null,
        adder: null,
        adderWrapper: null,
    };
    #services = {
        index: 0,
        items: {},
    };
    #events = {
        adder: {},
        remove: {},
    };

    static get viewName() {
        return 'ask-for-a-quote-step1';
    }
    static get viewType() {
        return 'page';
    }

    start() {
        this.#retrieveDOMElements();
        this.#addInitialServices();
        this.#setupAdder();
    }
    destroy() {
        this.#off('adder', 0);

        Object.keys(this.#events.remove).forEach(key => this.#off('remove', key));
    }

    #retrieveDOMElements() {
        this.#templates = {
            service: document.querySelector('#add-service-template'),
            activities: document.querySelector('#add-service-activities-template'),
        };

        const form  = document.querySelector('.step-1 form');
        const adder = form.querySelector('#adder');

        this.#form = {
            self: form,
            adder,
            adderWrapper: adder.parentNode,
        };
    }
    #addInitialServices() {
        const added = document.querySelector('#added-services');

        if (!added) {
            this.#addService();

            return;
        }

        const content  = added.content.cloneNode(true);
        const services = content.querySelectorAll('.add-service');
        const elements = this.#getServiceElementsFromTemplates();

        const insertServiceFromTemplates = (service, index, elements) => {
            const category            = service.querySelector('[checked]');
            const content             = service.querySelector('.add-service-content');
            const activitiesContainer = elements.activities.cloneNode(true).querySelector(`.add-service-activities[data-category="${category.value}"]`);
            const activities          = activitiesContainer.querySelectorAll('[data-view-name="field"]');

            // For legacy browsers
            if (!category.checked && (category.getAttribute('checked') === 'checked')) {
                category.checked = true;
            }

            activities.forEach(field => {
                if (field.value !== category.dataset.activity) {
                    return;
                }

                field.checked = true;
            });

            content.appendChild(activitiesContainer);

            service.dataset.index = index;

            this.#form.self.insertBefore(service, this.#form.adderWrapper);

            this.#updateFieldsIds(activities, index);
            this.#setFieldsViews(activities);
        };

        services.forEach(service => {
            this.#services.index++;

            insertServiceFromTemplates(service, this.#services.index, elements);

            this.#updateService(this.#services.index);
            this.#setServiceEvents(this.#services.index);
        });

        this.#setServicesCount();
    }
    #setupAdder() {
        this.#on('adder', 0, this.#form.adder, 'click', (e) => {
            e.preventDefault();

            this.#addService();
        });
    }
    #addService(categoryId) {
        this.#services.index++;

        const insertServiceFromTemplates = (index) => {
            const activityTarget = categoryId ? categoryId : (categoryId === false ? null : 'none');
            const elements       = this.#getServiceElementsFromTemplates();

            if (activityTarget) {
                const activity = elements.activities.querySelector(`.add-service-activities[data-category="${activityTarget}"]`);

                elements.service.content.self.appendChild(activity);
            }

            elements.service.self.firstElementChild.dataset.index = index;

            this.#form.self.insertBefore(elements.service.self, this.#form.adderWrapper);

            this.#setServicesCount();
        };

        insertServiceFromTemplates(this.#services.index);

        this.#updateService(this.#services.index);
        this.#setServiceEvents(this.#services.index);
    }
    #updateService(index) {
        const elements = this.#getServiceElementsFromDOM(index);

        this.#updateFieldsIds(elements.service.content.categories, index);
        this.#setFieldsViews(elements.service.content.categories);
    };
    #setServiceEvents(index) {
        const elements = this.#getServiceElementsFromDOM(index);

        this.#on('remove', elements.service.self.dataset.index, elements.service.header.remove, 'click', (e) => {
            e.preventDefault();

            this.#removeFieldsViews(elements.service.content.categories);
            this.#removeFieldsViews(elements.activities.querySelectorAll('[data-view-name]'));

            elements.service.self.remove();

            const { [elements.service.self.dataset.index]: trash, ...rest } = this.#services.items;

            this.#services.items = rest;

            this.#off('remove', elements.service.self.dataset.index);

            this.#setServicesCount();
        });

        elements.service.content.categories.forEach(category => {
            const listener = ({ target: { value } }) => {
                const template = this.#templates.activities.content.cloneNode(true).querySelector(`.add-service-activities[data-category="${value}"]`);

                this.#removeFieldsViews(elements.activities.querySelectorAll('[data-view-name="field"]'));

                elements.service.content.self.querySelector('.add-service-activities').outerHTML = template.outerHTML;
                elements.activities = elements.service.content.self.querySelector('.add-service-activities');

                const activities = elements.activities.querySelectorAll('[data-view-name="field"]');

                this.#updateFieldsIds(activities, elements.service.self.dataset.index);
                this.#setFieldsViews(activities);
            };

            const instance = View.instances.get(category.dataset.viewId);

            instance.addEventHandler('change', listener);
        });
    };
    #setServicesCount() {
        this.#form.self.querySelectorAll('.add-service-header-text .count').forEach((item, index) => {
            item.textContent = index + 1;
        });
    }

    #getServiceElementsFromTemplates() {
        const service = this.#templates.service.content.cloneNode(true);
        const content = service.querySelector('.add-service-content');

        return {
            service: {
                self: service,
                header: {
                    text: service.querySelector('.add-service-header-text'),
                    count: service.querySelector('.add-service-header-text .count'),
                    remove: service.querySelector('.add-service-header-remove'),
                },
                content: {
                    self: content,
                    categories: content.querySelectorAll('.add-service-categories [data-view-name="field"]'),
                },
            },
            activities: this.#templates.activities.content.cloneNode(true),
        };
    }
    #getServiceElementsFromDOM(index) {
        if (this.#services.items[index]) {
            return this.#services.items[index];
        }

        const service = this.#form.self.querySelector(`.add-service[data-index="${index}"]`);
        const content = service.querySelector('.add-service-content');

        this.#services.items[index] = {
            service: {
                self: service,
                header: {
                    text: service.querySelector('.add-service-header-text'),
                    count: service.querySelector('.add-service-header-text .count'),
                    remove: service.querySelector('.add-service-header-remove'),
                },
                content: {
                    self: content,
                    categories: content.querySelectorAll('.add-service-categories [data-view-name="field"]'),
                },
            },
            activities: service.querySelector('.add-service-activities'),
        };

        return this.#services.items[index];
    }

    #updateFieldsIds(fields, index) {
        const update = (field) => {
            const group = field.parentNode.parentNode;
            const label = group.querySelector('.selector-label');

            group.id = group.id.replace('--index', `--${index}`);
            field.id = field.id.replace('--index', `--${index}`);

            label.setAttribute('for', label.getAttribute('for').replace('--index', `--${index}`));

            field.setAttribute('name', field.getAttribute('name').replace('[index]', `[${index}]`));
            field.setAttribute('data-view-id', field.getAttribute('data-view-id').replace('--index', `--${index}`));
        };

        fields.forEach(update);
    }

    #setFieldsViews(fields) {
        View.initInstances(fields);

        this.#refreshFormFields();
    }
    #removeFieldsViews(fields) {
        fields.forEach(field => {
            const instance = View.instances.get(field.dataset.viewId);

            if (!instance) {
                return;
            }

            instance.destroy();

            View.instances.delete(field.dataset.viewId);
        });

        this.#refreshFormFields();
    }
    #refreshFormFields() {
        const form = View.instances.get(this.#form.self.dataset.viewId);

        form.refreshFields();
    }

    #on(key, index, element, eventType, listener) {
        element.addEventListener(eventType, listener);

        this.#events = {
            ...this.#events,
            [key]: {
                [index]: () => element.removeEventListener(eventType, listener),
            },
        };
    }
    #off(key, index) {
        if (!this.#events[key][index]) {
            return;
        }

        this.#events[key][index]();

        delete this.#events[key][index];
    }
}